import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    viewBox="0 0 21 21"
    {...props}
  >
    <path
      fill="#fff"
      d="M1.484 14.297a3.4 3.4 0 0 1 .86-1.445L14.219.977a2.523 2.523 0 0 1 3.554 0L19.297 2.5c.117.117.234.273.312.39a2.49 2.49 0 0 1-.312 3.165L7.422 17.93c-.04.039-.117.078-.156.156a4.2 4.2 0 0 1-1.29.703l-3.046.898-1.68.508a.89.89 0 0 1-.898-.273.8.8 0 0 1-.235-.899l.469-1.68zm1.797.547-.273.898-.625 2.149 2.148-.625.899-.274c.273-.078.468-.195.664-.39l8.945-8.946-2.422-2.422-8.945 8.946c-.04 0-.04.039-.078.078-.156.156-.235.351-.313.586"
    />
  </svg>
);
export default SvgPen;
